/**
 * @module getClientTimeouts
 */

import store from '../store/store';

/**
 * @function
 * To get the client timeouts from the satchel store
 * @returns The client timeouts
 */

const getClientTimeouts = () => {
    let timeouts = null;
    if (store.cache.data?.clientTimeouts?.default) {
        timeouts = store.cache.data.clientTimeouts.default;
    }
    return timeouts;
};

export default getClientTimeouts;
